import React, { useState } from "react";
import { Ingredient, Recipe } from "./Recipes";

type IngredientListItemProps = {
  ingredient: Ingredient;
};

const IngredientListItem = ({ ingredient }: IngredientListItemProps) => {
  return (
    <tr>
      <td
        className="text-center bg-light"
        style={{ width: "1%", borderRight: "1px solid #dee2e6" }}
      >
        {!!ingredient.measurement && (
          <span className="badge bg-light text-dark fs-6">
            {ingredient.measurement}
          </span>
        )}
      </td>
      <td>
        {ingredient.name}
        {!!ingredient.substitution && (
          <span className="text-secondary">
            &nbsp;or {ingredient.substitution.name}
          </span>
        )}
      </td>
    </tr>
  );
};

type IngredientListProps = {
  ingredients: Array<Ingredient>;
};

const IngredientList = ({ ingredients }: IngredientListProps) => {
  return (
    <table className="table" style={{ marginBottom: "-1px" }}>
      <tbody>
        {ingredients.map((ingredient) => (
          <IngredientListItem key={ingredient.name} ingredient={ingredient} />
        ))}
      </tbody>
    </table>
  );
};

type FavoriteIconProps = {
  favorites: Array<string>;
};

const FavoriteIcon = ({ favorites }: FavoriteIconProps) => {
  const favoriteToFillColor = (favorite: string) => {
    let fillColor = null;

    switch (favorite) {
      case "Ryan":
        fillColor = "orange";
        break;
      case "Val":
        fillColor = "green";
        break;
    }
    return fillColor;
  };

  return (
    <>
      {favorites.sort().map((favorite) => {
        let fillColor = favoriteToFillColor(favorite);

        if (fillColor) {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill={fillColor}
              className="bi bi-star-fill ms-2"
              viewBox="0 0 16 16"
            >
              <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
            </svg>
          );
        }
      })}
    </>
  );
};

type RecipeListItemProps = {
  index: number;
  recipe: Recipe;
};

const RecipeListItem = ({ index, recipe }: RecipeListItemProps) => {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`flush-heading-${index}`}>
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#flush-collapse-${index}`}
        >
          {recipe.name}
          {recipe.favorites && <FavoriteIcon favorites={recipe.favorites} />}
        </button>
      </h2>
      <div
        id={`flush-collapse-${index}`}
        className="accordion-collapse collapse"
        data-bs-parent="#recipe-list"
      >
        <div>
          <IngredientList ingredients={recipe.ingredients} />
        </div>
      </div>
    </div>
  );
};

type RecipeListProps = {
  recipes: Array<Recipe>;
};

const RecipeList = (props: RecipeListProps) => {
  return (
    <div id="recipe-list" className="accordion accordion-flush">
      {props.recipes.map((recipe, index) => (
        <RecipeListItem key={recipe.name} index={index} recipe={recipe} />
      ))}
    </div>
  );
};

type RecipeSearchProps = {
  recipes: Array<Recipe>;
};

export const RecipeSearch = ({ recipes }: RecipeSearchProps) => {
  const [queryInput, setQueryInput] = useState("");

  const filteredRecipes = recipes.filter((recipe) => {
    let query = queryInput.toLowerCase();

    // The recipe name matches the query.
    if (recipe.name.toLowerCase().includes(query)) {
      return true;
    }

    // Any of the recipe's ingredients (or substitutions) matches the query.
    return recipe.ingredients.find(
      (ingredient) =>
        ingredient.name.toLowerCase().includes(query) ||
        ingredient.substitution?.name.toLowerCase().includes(query)
    );
  });

  return (
    <main className="container-fluid mx-0 px-0">
      <nav className="navbar navbar-dark bg-primary">
        <form className="container-fluid">
          <div className="input-group">
            <span className="input-group-text" id="basic-addon1">
              Search
            </span>
            <input
              className="form-control"
              type="search"
              placeholder="Start typing a drink or ingredient name"
              onChange={(e) => setQueryInput(e.target.value)}
            />
          </div>
        </form>
      </nav>
      <RecipeList recipes={filteredRecipes} />
    </main>
  );
};
